import Coordination from '@/components/pages/Coordination/Coordination.vue'
import CoordinationSportsList from '@/components/pages/Coordination/CoordinationSportsList.vue'

export default [
  {
    path: '/coordination/:streamGroupName',
    name: 'coordination',
    component: Coordination,
    props: true,
    meta: {
      requiredAbilities: [
        'ligadv-table-tennis-coordination-khabarovsk',
        'ligapro-table-tennis-coordination-moscow',
        'ligapro-table-tennis-coordination-czech',
        'ligapro-table-tennis-coordination-minsk'
      ]
    }
  },
  {
    path: '/coordination',
    name: 'coordination-sports-list',
    component: CoordinationSportsList,
    meta: {
      requiredAbilities: [
        'ligadv-table-tennis-coordination-khabarovsk',
        'ligapro-table-tennis-coordination-moscow',
        'ligapro-table-tennis-coordination-czech',
        'ligapro-table-tennis-coordination-minsk'
      ]
    }
  }
]
